import { render, staticRenderFns } from "./CustomerLogView.vue?vue&type=template&id=35f66608&scoped=true&"
import script from "./CustomerLogView.vue?vue&type=script&lang=js&"
export * from "./CustomerLogView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLogView.vue?vue&type=style&index=0&id=35f66608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f66608",
  null
  
)

export default component.exports